import { createAction } from 'typesafe-actions';
import { SLOTS } from 'types';
import { ACTIONS } from './types';

export const setAvailableBetsAction = createAction(ACTIONS.SET_AVAILABLE_BETS)<SLOTS[]>();
